// removed by extract-text-webpack-plugin
module.exports = {"mainWrapper":"mainWrapper__12k22","headerWrapper":"headerWrapper__2dkMl","headerNavbarWrapper":"headerNavbarWrapper__2OvLC","headerActiveLink":"headerActiveLink__3cBC_"};


//////////////////
// WEBPACK FOOTER
// ./components/commonHeader/style.scss
// module id = UGm2
// module chunks = 0